
<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>
           ระบบตรวจสอบและติดตามเรือขนส่งน้ำมัน ©
        </span>
        <span class="md:flex hidden items-center">
         สำนักตรวจสอบ ป้องกันและปราบปราม กรมสรรพสามิต</span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
